import React from 'react'

import Section from '../../../../../../components/Section'
import { Purchase } from '../../../types'

const formatDate = (value: string | null | undefined) => {
    if (!value) {
        return {
            date: '',
        }
    }

    const date = new Date(value)

    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear()
    return {
        date: `${year}-${month}-${day}`,
    }
}

const formatDateTime = (value: string | null | undefined) => {
    if (!value) {
        return {
            date: '',
            time: '',
        }
    }

    const date = new Date(value)

    return {
        date: date.toLocaleDateString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        }),
        time: date.toLocaleTimeString('ru-RU', {
            hour: '2-digit',
            minute: '2-digit',
        }),
    }
}

type Props = {
    theme: string
    purchaseAction: boolean
    purchaseGuid: string | undefined
    purchasesLoading: boolean
    purchasesError: string | null
    purchase: Purchase
}

const PurchaseApplSubmision: React.FC<Props> = (props) => {
    return (
        <Section title="Подача заявок">
            <fieldset disabled={props.purchaseAction}>
                <div className="flex flex-col w-full gap-3">
                    <div className="flex flex-row w-full gap-x-5 items-start justify-start ">
                        <div className="flex flex-col w-[200px]">
                            <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                Дата начала срока подачи заявок{' '}
                                <span className="text-[#FF0000]">*</span>
                            </label>
                            <input
                                type="date"
                                className={`form-input user-input-placeholder w-full`}
                                value={
                                    props.purchase?.appl_submision_start_date ??
                                    ''
                                }
                                style={{
                                    colorScheme:
                                        props.theme == 'dark'
                                            ? 'dark'
                                            : 'light',
                                }}
                            />
                        </div>
                        <div className="flex flex-row w-full gap-x-5 items-end justify-start ">
                            <div className="flex flex-col w-[200px]">
                                <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                    Дата и время окончания срока подачи заявок
                                </label>
                                <input
                                    type="date"
                                    className={`form-input user-input-placeholder w-full`}
                                    value={
                                        formatDate(
                                            props.purchase
                                                ?.submission_close_date_time
                                        ).date ?? ''
                                    }
                                    style={{
                                        colorScheme:
                                            props.theme == 'dark'
                                                ? 'dark'
                                                : 'light',
                                    }}
                                />
                            </div>
                            <div className="flex flex-col w-[90px]">
                                <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                    {' '}
                                </label>
                                <input
                                    type="time"
                                    className={`form-input user-input-placeholder w-full`}
                                    value={
                                        formatDateTime(
                                            props.purchase
                                                ?.submission_close_date_time
                                        ).time ?? ''
                                    }
                                    style={{
                                        colorScheme:
                                            props.theme == 'dark'
                                                ? 'dark'
                                                : 'light',
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col w-full items-start justify-start ">
                        <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Порядок подачи заявок{' '}
                            <span className="text-[#FF0000]">*</span>
                        </label>
                        <textarea
                            className={`form-textarea w-full`}
                            maxLength={2000}
                            rows={3}
                            value={props.purchase?.appl_submision_order || ''}
                        />
                    </div>
                    <div className="flex flex-col w-full items-start justify-start ">
                        <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Место подачи заявок{' '}
                        </label>
                        <textarea
                            className={`form-textarea w-full`}
                            maxLength={2000}
                            rows={3}
                            value={props.purchase?.appl_submision_place || ''}
                        />
                    </div>
                </div>
            </fieldset>
        </Section>
    )
}

export default PurchaseApplSubmision
